/**
 * HACK: Fixes modus wc slider color.
 */
export function fixModusSliderStyle(): void {
  const styleId = 'fix-modus-slider';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
        /* This override ensures modus slider uses the same color as the switch toggle. */
        [data-theme=modus-classic-light] modus-wc-slider .modus-wc-range {
          --range-shdw: var(--modus-wc-color-blue-light);
        }

        .modus-wc-range {
            --range-shdw: var(--range-shadow);
            --slider-thumb-height: 20px;
            --slider-thumb-width: 20px;
            --slider-thumb-background: #ffffff;
        }
        
        .modus-wc-range-md {
            height: 20px;
        }

        input[type="range"].modus-wc-range-md::-webkit-slider-thumb { 
            height: var(--slider-thumb-height);
            width: var(--slider-thumb-width);
            background: var(--slider-thumb-background);
        }

        input[type="range"].modus-wc-range-md::-moz-range-thumb { 
            height: var(--slider-thumb-height);
            width: var(--slider-thumb-width);
            background: var(--slider-thumb-background);
        }

        input[type="range"].modus-wc-range-md::-ms-thumb { 
            height: var(--slider-thumb-height);
            width: var(--slider-thumb-width);
            background: var(--slider-thumb-background);
        }
    `;
    document.head.appendChild(style);
  }
}

/**
 * TODO: This is a temporary fix until a color picker control is available.
 */
export function applyColorInputStyle(): void {
  const styleId = 'fix-color-input';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      input[type="color"]::-webkit-color-swatch-wrapper { 
        padding: 0; 
      }

      input[type="color"]::-webkit-color-swatch { 
        border-radius: 10px; 
        border: 1px solid #90939f;
      }

      input[type="color"] { 
        outline: none; 
        border: none; 
        width: 40px; 
        min-width: 40px;
        height: 22px; 
        cursor: pointer; 
      }
    `;
    document.head.appendChild(style);
  }
}
